// extracted by mini-css-extract-plugin
export default {"dashboard-layout":"c8ccb9","dashboard-layout__main":"e90e8e","dashboard-layout__content":"cae981","dashboard-layout__content--cart":"cd3f37","scroll-top":"ab768e"};